export default __webpack_public_path__ + "static/productsans-medium-webfont-00b32df669a51fa5e80cf30aa21bd273.woff2";